module.exports = __webpack_public_path__ + "img/histogram.ab1a8151.svg";